import React from "react";
import MembershipAdvantages from "./components/MembershipAdvantages";

export default function FullMembershipOnly() {
  return <MembershipAdvantages title="Activate a full membership to view this content" isAuthenticated={true} isRV={true} />;
}
